import { clsx, type ClassValue } from "clsx"
import { format } from "date-fns"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function parseLocalDate(date: string) {
  return new Date(`${date}T12:00:00`)
}

export function formatLocalDate(date: string, dateFormat = "dd/MM/yyyy") {
  return format(parseLocalDate(date), dateFormat)
}

export function formatCuit(value: string) {
  const digits = value.replace(/\D/g, "").slice(0, 11)
  const prefix = digits.slice(0, 2)
  const body = digits.slice(2, 10)
  const checkDigit = digits.slice(10, 11)

  if (digits.length <= 2) return prefix
  if (digits.length <= 10) return `${prefix}-${body}`
  return `${prefix}-${body}-${checkDigit}`
}
